module.exports = __webpack_public_path__ + "static/assets/754bd51538baf65fcf01b851b187df9a.svg";